export enum App {
  Employer = 'EMPLOYER',
  Admin = 'ADMIN',
}
